module.exports = __webpack_public_path__ + "img/car-transport.f9403d6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/car-transport.svg
// module id = 70
// module chunks = 0